<template>
  <section class="seciton">
    <img class="banner" src="@/assets/ncov-japan-banner.jpg" />
    <div class="languages-button" @click="showLanguagesMenu = true">
      <Icon type="language" /> {{ $t('noun.language') }}
    </div>
    <FullScreenMenu
      :show="showLanguagesMenu"
      :title="$t('noun.language')"
      :options="languages"
      @select="switchLanguage"
      @close="showLanguagesMenu = false"
      />
  </section>
</template>

<script>
import Icon from '@/components/Icon'
import FullScreenMenu from '@/components/FullScreenMenu'
import { changeLocale } from '@/languages'

const LANGUAGES = [
  { name: '日本語', value: 'jp' },
  { name: 'English', value: 'en' },
  { name: '中文', value: 'zh' },
]

export default {
  name: 'Banner',
  data () {
    return {
      showLanguagesMenu: false,
      languages: LANGUAGES,
    }
  },
  methods: {
    switchLanguage (lang) {
      changeLocale(lang)
      this.showLanguagesMenu = false
    },
  },
  components: {
    Icon,
    FullScreenMenu,
  },
}
</script>

<style lang="less" scoped>
.section {
  position: relative;
  width: 100%;
}
.banner {
  width: 100%;
  max-width: 100%;
  display: block;
}
.languages-button {
  position: absolute;
  right: 0;
  top: 0;
  padding: 1em 2em;
  font-size: 12px;
  text-transform: capitalize;
  background: rgba(0,0,0,0.5);
  color: #fff;
  border-bottom-left-radius: 8px;
  cursor: pointer;
}
</style>
